export default __webpack_public_path__ + "media/images/landing-30-550x420-54030bde59b8f54fda21e13ad7c36591.jpg";